import React, { useEffect, useState } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import CookieConsent from "react-cookie-consent"; // ⬅️ Ajouté
import AnnuaireArtisans from "./pages/AnnuaireArtisans/AnnuaireArtisans";
import ChoixForfait from "./pages/ChoixForfait/ChoixForfait";
import LandingPage from "./pages/LandingPage/LandingPage";
import Login from "./pages/Login/Login";
import Signup from "./pages/Signup/Signup";
import { AuthProvider } from "./context/AuthContext";
import NavigationBar from "./layouts/Navbar/Navbar";
import AddProperty from "./pages/AddProperty/AddProperty";
import AddRoom from "./pages/AddRoom/AddRoom";
import ContactPage from "./pages/ContactPage/ContactPage";
import PaiementPage from "./pages/Paiement/PaiementPage";
import SuccessPage from "./pages/Paiement/SuccessPage";
import PropertyDetail from "./pages/PropertyDetail/PropertyDetail";
import PropertyList from "./pages/PropertyList/PropertyList";
import RoomDetail from "./pages/RoomDetail/RoomDetail";
import UserAccountPage from "./pages/UserAccountPage/UserAccountPage";
import WizardInscriptionArtisan from "./pages/WizardInscriptionArtisan/WizardInscriptionArtisan";
import FormulaireEntreprise from "./pages/FormulaireEntreprise/FormuaireEntreprise";
import PaiementArtisan from "./pages/PaiementArtisan/PaiementArtisan";
import supabase from "./supabase";
import { RenovCreditsProvider } from "./context/RenovCreditsContext";
import { UserPlanProvider } from "./context/UserPlanContext";
import { NotificationProvider } from "./context/NotificationContext";
import ConfirmEmail from "./pages/ConfirmEmail/ConfirmEmail";
import SuccessPaiementArtisan from "./pages/SuccessPaiementArtisan/SuccessPaiementArtisan";
import SuccessRechargeRC from "./pages/SuccessRechargeRC/SuccessRechargeRC";
import Footer from "./layouts/Footer/Footer";
import MentionsLegales from "./pages/MentionsLegales/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite/PolitiqueConfidentialite";
import PolitiqueCookies from "./pages/PolitiqueCookies/PolitiqueCookies";
import EntrepriseContactPage from "./pages/EntrepriseContactPage/EntrepriseContactPage";
import NotFound from "./pages/NotFound/NotFound";
import { loadGTM } from "./utils/gtm";
import DashboardArtisan from "./pages/DashboardArtisan/DashboardArtisan";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const checkAuthStatus = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      setUser(user);
  
      if (user) {
        const { data: profileData } = await supabase
          .from("profiles")
          .select("account_type")
          .eq("id", user.id)
          .single();
        setProfile(profileData);
      }
  
      setLoading(false);
    };

    checkAuthStatus();

    const { subscription } = supabase.auth.onAuthStateChange(
      (event, session) => {
        setUser(session?.user || null);
      }
    );

    loadGTM("G-SKLRB0M76B");

    const consent = document.cookie.includes("renovestimConsent=true");
    if (consent) {
    }

    

    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  if (loading) return <div>Chargement...</div>;

  return (
    <AuthProvider>
      <RenovCreditsProvider>
        <UserPlanProvider>
          <NotificationProvider>
            <Router>
              <div className="d-flex flex-column min-vh-100">
                <NavigationBar />
                <Routes>
                  <Route
                    path="/"
                    element={
                      user ? (
                        profile?.account_type === "Artisan" ? (
                          <Navigate to="/dashboard-artisan" />
                        ) : (
                          <Navigate to="/properties" />
                        )
                      ) : (
                        <LandingPage />
                      )
                    }
                  />
                  <Route
                    path="/login"
                    element={user ? <Navigate to="/properties" /> : <Login />}
                  />
                  <Route
                    path="/signup"
                    element={user ? <Navigate to="/properties" /> : <Signup />}
                  />
                  <Route path="/annuaire" element={<AnnuaireArtisans />} />
                  <Route path="/choix-forfait" element={<ChoixForfait />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route
                    path="/contact-entreprise"
                    element={<EntrepriseContactPage />}
                  />
                  <Route
                    path="/inscription-artisan"
                    element={<WizardInscriptionArtisan />}
                  />
                  <Route
                    path="/formulaire-entreprise"
                    element={<FormulaireEntreprise />}
                  />
                  <Route
                    path="/paiement-artisan"
                    element={<PaiementArtisan />}
                  />
                  <Route path="/confirm" element={<ConfirmEmail />} />
                  <Route path="/success" element={<SuccessPaiementArtisan />} />
                  <Route
                    path="/success-recharge"
                    element={<SuccessRechargeRC />}
                  />
                  <Route
                    path="/mentions-legales"
                    element={<MentionsLegales />}
                  />
                  <Route
                    path="/politique-confidentialite"
                    element={<PolitiqueConfidentialite />}
                  />
                  <Route
                    path="/politique-cookies"
                    element={<PolitiqueCookies />}
                  />
                  <Route
                    path="/properties"
                    element={user ? <PropertyList /> : <Navigate to="/" />}
                  />
                  <Route
                    path="/property/:id"
                    element={user ? <PropertyDetail /> : <Navigate to="/" />}
                  />
                  <Route
                    path="/add-property"
                    element={user ? <AddProperty /> : <Navigate to="/" />}
                  />
                  <Route
                    path="/property/:id/add-room"
                    element={user ? <AddRoom /> : <Navigate to="/" />}
                  />
                  <Route
                    path="/property/:id/room/:id"
                    element={user ? <RoomDetail /> : <Navigate to="/" />}
                  />
                  <Route
                    path="/moncompte"
                    element={user ? <UserAccountPage /> : <Navigate to="/" />}
                  />
                  <Route
                    path="/paiement"
                    element={user ? <PaiementPage /> : <Navigate to="/" />}
                  />
                  <Route
                    path="/success"
                    element={user ? <SuccessPage /> : <Navigate to="/" />}
                  />
                  <Route
                    path="/dashboard-artisan"
                    element={user ? <DashboardArtisan /> : <Navigate to="/" />}
                  />
                  <Route path="*" element={<NotFound />} />
                </Routes>

                {/* ⬇️ Bannière de consentement Cookie RGPD */}
                <CookieConsent
                  location="bottom"
                  buttonText="Accepter"
                  declineButtonText="Refuser"
                  enableDeclineButton
                  cookieName="renovestimConsent"
                  style={{ background: "#343a40" }}
                  buttonStyle={{
                    backgroundColor: "#ffa500",
                    color: "#000",
                    fontSize: "13px",
                  }}
                  declineButtonStyle={{
                    backgroundColor: "#6c757d",
                    color: "#fff",
                    fontSize: "13px",
                  }}
                  expires={180}
                >
                  Nous utilisons des cookies pour améliorer votre expérience sur
                  Renovestim.{" "}
                  <a
                    href="/politique-cookies"
                    style={{ color: "#ffa500", textDecoration: "underline" }}
                  >
                    En savoir plus
                  </a>
                </CookieConsent>

                <Footer />
              </div>
            </Router>
          </NotificationProvider>
        </UserPlanProvider>
      </RenovCreditsProvider>
    </AuthProvider>
  );
}

export default App;